import { format } from 'date-fns';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';

const formatDate = (date: Date): string => format(date, 'yyyy_MM_dd');

export const buildFilename = (projectKey: ProjectKey, date: Date): string =>
	`deployments_${projectKey}_${formatDate(date)}.csv`;
